import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Hero from "../components/hero"
import Sections from "../components/sections"
import { Helmet } from "react-helmet"
// import { IntlProvider, useIntl } from "react-intl"

const PageTemplate = ({ data, location }) => {
  const page = data?.page
  const locale = location?.pathname?.startsWith('/es/') ? 'es' : 'en'
  const translations = locale !== "en" ? data?.wordprezz?.page?.translations ? data?.wordprezz?.page?.translations?.find(
    (translation) => translation?.languageCode === locale
  ) : null : null
  const customSections = page?.customSections
  // const translatedCustomSections = translations?.customSections
  const title = translations?.hero?.heading || translations?.title || page?.hero?.heading || page?.title
  // const intl = useIntl()
  // const messages = { 
  //   en: {title: page.title}, 
  //   es: {title: page.translations[0]?.title }
  // };
  // console.log(messages)
  const hero = {
    ...page.hero,
    ...translations?.hero,
  }

  const seo = {
    ...page.seo,
    ...translations?.seo,
  }
  return (
    <Layout isHomePage={page.uri === '/'} uri={page.uri} locale={locale}>
      
      <Seo
        // title={page.seo?.title ? intl.formatMessage(page.seo?.title) : page.title ? intl.formatMessage(page.title) : null}
        title={seo?.title || title}
        description={seo?.metaDesc}
        image={seo?.opengraphImage?.localFile?.publicURL}
      />
      <Helmet
        htmlAttributes={{
          lang: locale,
        }}
      />
      {/* <div className="py-12">
        <Link to="/page-2/">
          <FormattedMessage id="title" />
        </Link>
        <IntlProvider>
          <p>
            <FormattedMessage
              id="title"
            />
          </p>
        </IntlProvider>
      </div> */}
      <Hero props={hero} title={title} />
      {customSections?.sections && (
        <Sections props={customSections} translations={translations?.customSections?.sections} />
      )}
    </Layout>
  )
}

export default PageTemplate

export const query = graphql`
  fragment PageData on WpPage {
    title
    languageCode
    uri
    seo {
      title
      metaDesc
      opengraphImage {
        localFile {
          publicURL
        }
      }
    }
    hero {
      heading
      image {
        altText
        localFile {
          publicURL
          extension
          childImageSharp {
            gatsbyImageData(width: 2560)
          }
        }
      }
      dropdown {
        items {
          item {
            target
            title
            url
          }
        }
        placeholder
      }
      imageOptions {
        imageFocus
      }
    }
    customSections {
      sections {
        ... on WpPage_Customsections_Sections_Content {
          fieldGroupName
          content
          heading
          image {
            altText
            localFile {
              publicURL
              extension
              childImageSharp {
                gatsbyImageData(width: 1024)
              }
            }
          }
          documents {
            document {
              localFile {
                extension
                publicURL
              }
              title
              description
              mediaDetails {
                sizes {
                  sourceUrl
                }
              }
            }
            preview: documentPreview {
              altText
              localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(width: 328)
                }
              }
            }
          }
          link {
            target
            title
            url
          }
          imageOptions {
            imageBorder
            imageCrop
            imageFocus
          }
          backgroundColor
          textSize
          curves {
            topCurve
          }
          linkOptions {
            format
          }
        }
        ... on WpPage_Customsections_Sections_Locations {
          fieldGroupName
          heading
        }
        ... on WpPage_Customsections_Sections_Portal {
          portalUrl
          fieldGroupName
          sizing
        }
        ... on WpPage_Customsections_Sections_Alert {
          fieldGroupName
          heading
          text
          link {
            target
            title
            url
          }
          icon {
            altText
            localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(width: 328)
                }
              }
          }
        }
        ... on WpPage_Customsections_Sections_Tableau {
          fieldGroupName
          tableauEmbed
        }
        ... on WpPage_Customsections_Sections_Form {
          fieldGroupName
          formType
          message
        }
        ... on WpPage_Customsections_Sections_Policy {
          policyIdAndOptions
          fieldGroupName
        }
      }
      flipSections
    }
  }
`

export const pageQuery = graphql`
  query WordPressPage($translateId: ID!, $id: String!) {
    wordprezz {
      page (id: $translateId) {
        translations {
          title
          languageCode
          uri
          seo {
            title
            metaDesc
          }
          hero {
            heading
            dropdown {
              items {
                item {
                  target
                  title
                  url
                }
              }
              placeholder
            }
          }
          customSections {
            sections {
              ... on WordPrezz_Page_Customsections_Sections_Content {
                fieldGroupName
                content
                heading
                link {
                  target
                  title
                  url
                }
              }
              ... on WordPrezz_Page_Customsections_Sections_Locations {
                fieldGroupName
                heading
              }
              ... on WordPrezz_Page_Customsections_Sections_Portal {
                fieldGroupName
              }
              ... on WordPrezz_Page_Customsections_Sections_Alert {
                fieldGroupName
                heading
                text
                link {
                  target
                  title
                  url
                }
              }
              ... on WordPrezz_Page_Customsections_Sections_Tableau {
                fieldGroupName
              }
              ... on WordPrezz_Page_Customsections_Sections_Form {
                fieldGroupName
                message
              }
              ... on WordPrezz_Page_Customsections_Sections_Policy {
                fieldGroupName
              }
            }
          }
        }
      }
      # parentPage: page (id: { eq: $originalId }) {
      #   ...PageData
      # }
    }
    page: wpPage(id: { eq: $id }) {
      ...PageData
    }
  }
`
